import type { ComponentProps } from "react"

export type PackageProps = ComponentProps<"div">
function Package(props: PackageProps) {
  return <div {...props} />
}

export default Package
